import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "module-item__icon" }
const _hoisted_2 = {
  key: 0,
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "module-item__copy" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["ai-module-list", `ai-module-list--${_ctx.align}`])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.title,
        class: _normalizeClass(["module-item", `module-item--${item.status}`])
      }, [
        _createElementVNode("span", _hoisted_1, [
          (item.status === 'done')
            ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("path", { d: "M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" }, null, -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString(item.title), 1),
          _createElementVNode("span", null, _toDisplayString(item.desc), 1)
        ])
      ], 2))
    }), 128))
  ], 2))
}